export const addProject = project => ({
  name: project.name,
  rate: project.rate,
  active: true
})

export const toggleProjectStatus = ({ name, rate, active }) => ({
  name,
  rate,
  active: !active
})



// WEBPACK FOOTER //
// ./src/actions/projects.js